<script>
  import TitleCard from '../assets/general/titlecard.svelte';
  import Title from '../assets/general/title.svelte';
  import ConnectHeader from '../assets/connect/connectheader.svelte';
  import PodcastWidget from '../assets/connect/PodcastWidget.svelte';
  import PodcastLinks from '../assets/connect/PodcastLinks.svelte';
  import HorizontalLine from '../assets/general/HorizontalLine.svelte';
  import Img from '../assets/general/ImageLightBox.svelte';
  import Button from '../routes/button.svelte';
</script>

<main>
	<TitleCard
	header="Connect"
	backgroundImage="FWTsOnBus.jpg"
	/>
	<ConnectHeader
	/>
	<Title
		text="Content"
	/>
<div class="image-text-container">
	<div class="image-container">
		<img src="../images/logos/FWPLogo.svg" width="343px" height="343px">
	</div>
	<div class="text-wrapper">
		<p>Hosted by renowned educator Erin Gruwell, the Freedom Writers Podcast features thought-provoking conversations with leaders, activists, educators, and storytellers. Past guests include:<br><br><ul><li>Original Freedom Riders, Jim Zwerg and Congressman John Lewis</li><li>Former Congressman Patrick Kennedy</li><li>Dolores Huerta</li><li>Dr. Pedro Noguera</li><li>Isha Sesay</li><li>Liz Murray</li><li>Parkland Students</li><li>And many more…</li></ul><br><br>
	</div>
</div>
	<HorizontalLine
	/>
	<div class="container">
		<img src="../images/backgrounds/Podcast-Guest-Banner.png" max-width="90%">
		<h2>Recent Episodes</h2>
		<PodcastWidget
		/>
		<h2>Subscribe to the Freedom Writers Podcast!</h2>
		<PodcastLinks
		/>
	</div>
	<HorizontalLine
	/>
	<div class="container">
		<h2>Want to help us produce more content like this?</h2>
	</div>
	<div class="split-screen">
  <div class="half">
    <div class="small-container">
      <h3>Be a patron!</h3><br>
      <p>Support the production of the Freedom Writers Podcast through a donation.</p>
      <br>
      <center><Button
        text="DONATE NOW"
        link="../donate"
      /></center>
    </div>
  </div>
  <div class="half">
    <div class="small-container">
      <h3>Be a sponsor!</h3><br>
      <p>Connect with our audience through branded content or paid advertisements.</p>
      <br>
      <center><Button
        text="CONTACT US"
        link="mailto:podcast@freedomwritersfoundation.org"
      /></center>
    </div>
  </div>
</div>
</main>

<style>
  .split-screen {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around; /* Ensures equal spacing around each half */
    align-items: center; /* Vertically centers the content */
    width: 90%;
    margin: 0 auto; /* Centers the split-screen container */
  }

  .half {
    flex: 1 1 45%; /* Allows for space between the halves, adjusting for content size */
    position: relative;
    margin: 1rem;
    width: 450px;
    display: flex;
    justify-content: center; /* Horizontally centers the content */
    align-items: center; /* Vertically centers the content */
    text-align: center; /* Ensures text within the div is centered */
  }

  .half:first-child::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0; /* Adjust if needed */
    bottom: 5%; /* Adjust so the line ends appropriately */
    width: 1px;
    background-color: #f7931e; /* Color of the divider */
    display: block;
  }

  h3 {
    font-family: 'Oswald';
    size: 3.4rem;
    color: #f7931e;
  }

  .small-container {
    text-align: left;
    line-height: 1.7rem;
    color: #000;
    max-width: 80%;
  }

  .image-text-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    line-height: 1.7rem;
  }

  ul {
    padding: 0 0 0 7rem;
  }

  .image-container {
    padding: 2rem 0;
    justify-content: center;
    align-content: center;
    display: flex;
    flex-basis: 25%;
  }

  .text-wrapper {
    padding: 3.4rem;
    flex-basis: 60%;
  }

  .container {
    margin: 0 7%;
  }

  .container img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }

  h2 {
    font-family: 'Oswald';
    font-weight: bold;
    font-size: 1.7rem;
    margin: 1rem 0;
  }

  /* Responsive design adjustments for mobile screens */
  @media (max-width: 768px) {
    .image-text-container {
        flex-direction: column;
        margin: 0 7%;
    }

    ul {
        padding: 0 0 0 3.4rem;
    }

    .image-container {
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .text-wrapper {
        width: 100%;
    }

    .split-screen {
        flex-direction: column;
        width: 100%;
    }

    .half {
        margin: 1rem;
        flex-basis: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 90%;
    }

    .half:first-child {
        padding-bottom: 1rem;
        border-bottom: 1px solid #f7931e; /* Adds a horizontal line for visual separation */
    }

    /* Removes the vertical line for mobile views */
    .half:first-child::after {
        content: none;
    }
  }
</style>